import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getReqMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry, formType, initialEntry) => {
    let newErrors = {};

    if (!newEntry.measurement || +newEntry.measurement < 1) {
        newErrors = {
            ...newErrors,
            measurement: { error: true, message: getReqMessage('Measurement') }
        };
    }

    if (!newEntry.measurementDate) {
        newErrors = {
            ...newErrors,
            measurementDate: { error: true, message: getReqMessage('Date') }
        };
    } else if (isDateFuture(newEntry.measurementDate)) {
        newErrors = {
            ...newErrors,
            measurementDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (Object.keys(newErrors).length < 1 && formType === 'edit') {
        newErrors = checkDiff(newEntry, initialEntry);
    }

    return newErrors;
};
